<template>
  <div class="what-cloud-enterprise">
    <div class="content-center">
      <div class="module-header">
        <div class="module-title">什么是云企业？</div>
        <div class="double-arrow"></div>
      </div>
      <FadeInBox>
        <div class="module-title text-primary">新基建行业新型数智化协作生态</div>
        <div class="module-subtitle">构建全新商业模式，为传统企业提供一站式云服务赋能</div>
        <div class="module-body">
          <div class="content-title">易隆创云企业平台</div>
          <div class="content-subtitle">易隆创云企业平台以 “共享模式 × 行业特色 × 企业属性” 为内核，打造新基建领域新型企业形态</div>
          <div class="content-item-container">
            <div class="content-item gxms">
              <div class="content-item-name">共享模式</div>
              <div class="content-item-text">零成本复用资质、集采供应链，按项目灵活组队，降低 90% 资源获取成本</div>
            </div>
            <div class="content-item hyts">
              <div class="content-item-name">行业特色</div>
              <div class="content-item-text">资质资金技术全赋能，投标施工维保全托管，适配新基建强管理、长周期特性</div>
            </div>
            <div class="content-item qysx">
              <div class="content-item-name">企业属性</div>
              <div class="content-item-text">保留云企业品牌与决策权，平台只做资源池，项目核心运作自主掌控</div>
            </div>
          </div>
        </div>
      </FadeInBox>
      <div class="double-arrow"></div>
    </div>
  </div>
</template>

<script>
import FadeInBox from './FadeInBox.vue';

export default {
  components: { FadeInBox },
};
</script>

<style lang="less" scoped>
.what-cloud-enterprise {
  padding: 64px 0 8px;
  background-color: #fff;

  .content-center {
    > .double-arrow {
      height: 96px;
    }
    .module-header > .double-arrow {
      margin: 24px 0;
    }
    .module-body {
      margin: 32px 0 8px;
      padding: 70px 48px 62px;
      background-color: #F5F5F6;
      border-radius: 8px;

      .content-title {
        font-family: @font-medium;
        font-size: 20px;
      }
      .content-subtitle {
        margin-top: 16px;
        color: #666;
      }
      .content-item-container {
        margin-top: 35px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .content-item {
          width: 372px;
          height: 158px;
          padding: 32px 24px;
          + .content-item {
            margin-left: 34px;
          }
          .content-item-name {
            font-family: @font-medium;
            font-size: 18px;
          }
          .content-item-text {
            margin-top: 16px;
            font-size: 14px;
            line-height: 26px;
            text-align: justify;
          }

          &.gxms {
            background-image: url('@/assets/img/cooperation/WhatCloudEnterprise/item_bg_gxms.png');
            background-size: 100% 100%;
            .content-item-name {
              color: #394A90;
            }
          }
          &.hyts {
            background-image: url('@/assets/img/cooperation/WhatCloudEnterprise/item_bg_hyts.png');
            background-size: 100% 100%;
            .content-item-name {
              color: #1E6D7C;
            }
          }
          &.qysx {
            background-image: url('@/assets/img/cooperation/WhatCloudEnterprise/item_bg_qysx.png');
            background-size: 100% 100%;
            .content-item-name {
              color: #308B72;
            }
          }
        }
      }
    }
  }
}
</style>
